import { useTheme } from '../../context/ThemeContext';
import { X } from 'lucide-react';

const APPLE_URL  = 'https://apps.apple.com/za/app/tripdata-sa-logbook/id6761355128';
const GOOGLE_URL = 'https://play.google.com/store/apps/details?id=com.codebooth.TripDataApp';

const ComingSoonModal = ({ isOpen, onClose }) => {
  const theme = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="relative w-full max-w-md rounded-3xl p-8 shadow-2xl animate-fade-in"
        style={{ backgroundColor: theme.card }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full transition-colors hover:opacity-70"
          style={{ color: theme.textMuted }}
        >
          <X size={20} />
        </button>

        {/* App icon */}
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 bg-gradient-brand"
          style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)' }}
        >
          {/* Car icon */}
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"/>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 6H5l-2 6h18l-2-6h-3"/>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 13v4h18v-4"/>
          </svg>
        </div>

        {/* Content */}
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold mb-2" style={{ color: theme.text }}>
            Download TripData
          </h3>
          <p className="text-base" style={{ color: theme.textSecondary }}>
            Available on iOS and Android.
          </p>
        </div>

        {/* Store buttons */}
        <div className="flex flex-col gap-3">
          {/* Apple - live */}
          <a
            href={APPLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 w-full py-3 px-6 rounded-full font-semibold text-white bg-gradient-brand transition-all duration-200 hover:opacity-90"
          >
            {/* Apple logo */}
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            Download on the App Store
          </a>

          {/* Google Play - live */}
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 w-full py-3 px-6 rounded-full font-semibold transition-all duration-200 hover:opacity-90"
            style={{ backgroundColor: theme.background, color: theme.text, border: `1px solid ${theme.border}` }}
          >
            {/* Google Play logo */}
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 20.5v-17c0-.83 1-.83 1.5-.5l14 8.5c.5.3.5 1 0 1.3l-14 8.5c-.5.3-1.5.3-1.5-.8z"/>
            </svg>
            Get it on Google Play
          </a>
        </div>

        <p className="text-xs text-center mt-6" style={{ color: theme.textMuted }}>
          Free to download · Free tier forever
        </p>
      </div>
    </div>
  );
};

export default ComingSoonModal;